export default "__VITE_ASSET__BZWNxze$__"